import { isNull } from 'lodash'
import moment from 'moment/moment'

export function numberFormat(
    value,
    digits = 2,
    style = 'decimal', // decimal, currency, percent, unit
    replace = false
) {
    value = style === 'percent' ? value / 100 : value
    const number = new Intl.NumberFormat('en-IN', {
        style: style,
        currency: 'INR',
        minimumFractionDigits: 0,
        maximumFractionDigits: digits,
        // roundingMode: 'floor',
    }).format(value)
    if (replace) return number.replaceAll(',', '')
    return number
}

export function userName(user) {
    if (!user) return
    return (
        <div className="flex items-center gap-3">
            <div className="relative w-full h-11 max-w-11">
                <img src={user.image_url + '?h=44&w=44&aspect=true&type=webp'} alt={user.name} />
            </div>
            <div className="w-full truncate">
                <p className="text-black dark:text-white">{user.name}</p>
                <p className="text-xs font-medium">{user.email}</p>
            </div>
        </div>
    )
}

export function accountName(bank_account) {
    if (!bank_account) return
    return (
        <div className="flex items-center gap-3">
            <div className="w-full truncate">
                <p className="text-black dark:text-white">{bank_account.name}</p>
                <p className="text-xs font-medium">{bank_account.number}</p>
            </div>
        </div>
    )
}

export function userVerified(verified, check = false) {
    var className = ''
    var name = ''
    switch (verified) {
        case null:
            className = 'text-danger bg-danger'
            name = 'Not Verified'
            break
        default:
            className = 'text-success bg-success'
            name = 'Verified'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function userStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 0:
            className = 'text-danger bg-danger'
            name = 'Inactive'
            break
        case 1:
            className = 'text-success bg-success'
            name = 'Active'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Inactive',
                },
                {
                    id: 1,
                    label: 'Active',
                },
            ]
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function lockStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 0:
            className = 'text-danger bg-danger'
            name = 'Lock'
            break
        case 1:
            className = 'text-success bg-success'
            name = 'Unlock'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Lock',
                },
                {
                    id: 1,
                    label: 'Unlock',
                },
            ]
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function yesNo(type = '', check = false) {
    var className = ''
    var name = ''
    switch (type) {
        case 0:
            className = 'text-danger bg-danger'
            name = 'No'
            break
        case 1:
            className = 'text-success bg-success'
            name = 'Yes'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'No',
                },
                {
                    id: 1,
                    label: 'Yes',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function userRole(guard, check = false) {
    var className = ''
    var name = ''
    switch (guard) {
        case 'admin':
            className = 'text-danger bg-danger'
            name = 'Admin'
            break
        case 'user':
            className = 'text-success bg-success'
            name = 'User'
            break
        default:
            className = 'text-info bg-info'
            name = 'Inspector'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function userType(type = '', check = false) {
    var className = ''
    var name = ''
    switch (type) {
        case 0:
            className = 'text-success bg-success'
            name = 'Vendor'
            break
        case 1:
            className = 'text-danger bg-danger'
            name = 'Customer'
            break
        case 2:
            className = 'text-info bg-info'
            name = 'Store'
            break
        case 3:
            name = [
                {
                    id: 0,
                    label: 'Vendor',
                },
                {
                    id: 1,
                    label: 'Customer',
                },
            ]
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Vendor',
                },
                {
                    id: 1,
                    label: 'Customer',
                },
                {
                    id: 2,
                    label: 'Store',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function accountType(type = '', check = false) {
    var className = ''
    var name = ''
    switch (type) {
        case 0:
            className = 'text-danger bg-danger'
            name = 'Savings'
            break
        case 1:
            className = 'text-success bg-success'
            name = 'Current'
            break
        case 2:
            className = 'text-info bg-info'
            name = 'Loan'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Savings',
                },
                {
                    id: 1,
                    label: 'Current',
                },
                {
                    id: 2,
                    label: 'Loan',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function transactionType(type = '', check = false) {
    var className = ''
    var name = ''
    switch (type) {
        case 0:
            className = 'text-success bg-success'
            name = 'Credit'
            break
        case 1:
            className = 'text-danger bg-danger'
            name = 'Debit'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Credit',
                },
                {
                    id: 1,
                    label: 'Debit',
                },
                {
                    id: 2,
                    label: 'Transfer',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function walletTransactionType(type = '', check = false) {
    var className = ''
    var name = ''
    switch (type) {
        case 0:
            className = 'text-success bg-success'
            name = 'Credit'
            break
        case 1:
            className = 'text-danger bg-danger'
            name = 'Debit'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Credit',
                },
                {
                    id: 1,
                    label: 'Debit',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function productUNIT(type = '', check = false) {
    var className = ''
    var name = ''
    switch (type) {
        case 0:
            className = 'text-danger bg-danger'
            name = 'MTR'
            break
        case 1:
            className = 'text-info bg-info'
            name = 'BDL'
            break
        case 2:
            className = 'text-primary bg-primary'
            name = 'NOS'
            break
        case 3:
            className = 'text-warning bg-warning'
            name = 'BOX'
            break
        case 4:
            className = 'text-success bg-success'
            name = 'LOT'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'MTR',
                },
                {
                    id: 1,
                    label: 'BDL',
                },
                {
                    id: 2,
                    label: 'NOS',
                },
                {
                    id: 3,
                    label: 'BOX',
                },
                {
                    id: 4,
                    label: 'LOT',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function productStoreStatus(status, check = false) {
    if (isNull(status)) return
    var className = ''
    var name = ''
    switch (status) {
        case 2:
            className = 'text-danger bg-danger'
            name = 'Reject'
            break
        case 1:
            className = 'text-success bg-success'
            name = 'Accept'
            break
        default:
            className = 'text-info bg-info'
            name = 'Pending'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function purchaseStatus(status, check = false) {
    if (isNull(status)) return
    var className = ''
    var name = ''
    switch (status) {
        case 2:
            className = 'text-danger bg-danger'
            name = 'Reject'
            break
        case 1:
            className = 'text-success bg-success'
            name = 'Accept'
            break
        default:
            className = 'text-info bg-info'
            name = 'Pending'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function storeOrderStatus(status, check = false) {
    if (isNull(status)) return
    var className = ''
    var name = ''
    switch (status) {
        case 4:
            className = 'text-warning bg-warning'
            name = 'Hold'
            break
        case 3:
            className = 'text-success bg-success'
            name = 'Done'
            break
        case 2:
            className = 'text-danger bg-danger'
            name = 'Reject'
            break
        case 1:
            className = 'text-secondary bg-secondary'
            name = 'Accept'
            break
        default:
            className = 'text-info bg-info'
            name = 'Pending'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function orderStatus(status, check = false) {
    if (isNull(status)) return
    var className = ''
    var name = ''
    switch (status) {
        case 2:
            className = 'text-danger bg-danger'
            name = 'Reject'
            break
        case 1:
            className = 'text-success bg-success'
            name = 'Accept'
            break
        default:
            className = 'text-info bg-info'
            name = 'Pending'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function orderType(type = '', check = false) {
    var className = ''
    var name = ''
    switch (type) {
        case 0:
            className = 'text-danger bg-danger'
            name = 'SPA'
            break
        case 1:
            className = 'text-info bg-info'
            name = 'Policy'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'SPA',
                },
                {
                    id: 1,
                    label: 'Policy',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function paymentStatus(status, check = false) {
    if (isNull(status)) return
    var className = ''
    var name = ''
    switch (status) {
        case 2:
            className = 'text-warning bg-warning'
            name = 'Partial'
            break
        case 1:
            className = 'text-success bg-success'
            name = 'Paid'
            break
        default:
            className = 'text-info bg-info'
            name = 'Pending'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function paymentTerms(type = '', check = false) {
    var className = ''
    var name = ''
    switch (type) {
        case 0:
            className = 'text-danger bg-danger'
            name = '7 days'
            break
        case 1:
            className = 'text-info bg-info'
            name = '15 days'
            break
        case 2:
            className = 'text-info bg-info'
            name = '30 days'
            break
        case 3:
            className = 'text-primary bg-primary'
            name = '45 days'
            break
        case 4:
            className = 'text-warning bg-warning'
            name = '60 days'
            break
        case 5:
            className = 'text-success bg-success'
            name = '90 days'
            break
        default:
            name = [
                {
                    id: 0,
                    label: '7 days',
                },
                {
                    id: 1,
                    label: '15 days',
                },
                {
                    id: 2,
                    label: '30 days',
                },
                {
                    id: 3,
                    label: '45 days',
                },
                {
                    id: 4,
                    label: '60 days',
                },
                {
                    id: 5,
                    label: '90 days',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export const getFinancialYearDates = () => {
    const now = moment()
    const currentMonth = now.month()
    const currentYear = now.year()

    let fyStart, fyEnd
    if (currentMonth < 3) {
        fyStart = moment()
            .year(currentYear - 1)
            .month(3)
            .startOf('month')
        fyEnd = moment().year(currentYear).month(2).endOf('month')
    } else {
        fyStart = moment().year(currentYear).month(3).startOf('month')
        fyEnd = moment()
            .year(currentYear + 1)
            .month(2)
            .endOf('month')
    }

    return {
        start: fyStart.locale('en').format('YYYY-MM-DD'),
        end: fyEnd.locale('en').format('YYYY-MM-DD'),
    }
}
